<template>
  <div class="player-spotlight">
    <b-container class="player-spotlight-container">
      <h3 v-if="global.screenWidth <= 768 || reverse">{{ playerName }}</h3>
      <div class="dual-col" :class="[ {reverseCol: reverse}, orientation ]">
        <div class="content-column" :class="orientation">
          <ImageGallery
            :data="playerImages"
            :idString="playerName.trim().replace(' ', '')"
          />
          <div v-if="playerQuote" class="player-quote">
            <span>
              {{ playerQuote }}
            </span>
          </div>
          <slot v-if="global.screenWidth > 768" name="splitB"></slot>
        </div>
        <div class="divider" :class="orientation" />
        <div class="content-column" :class="orientation">
          <h3 v-if="!reverse && global.screenWidth >= 768">{{ playerName }}</h3>
          <slot name="primaryParagraph"></slot>
          <slot v-if="global.screenWidth <= 768" name="splitCombined"></slot>
          <slot v-else name="splitA"></slot>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import ImageGallery from "@/components/global/ImageGallery";
import { mapState } from "vuex";
export default {
  name: "PlayerSpotlight",
  components: {
    ImageGallery,
  },
  props: {
    playerName: {
      type: String,
      required: true,
    },
    playerImages: {
      type: Array,
      required: true,
    },
    playerQuote: {
      type: String,
      required: false,
    },
    reverse: {
      type: Boolean,
      required: false,
    },
    mobileTextExists: {
      type: Boolean,
      required: false,
    },
    orientation: {
      type: String,
      required: false
    }
  },
  data() {
    return {};
  },
  // mounted() {
  //   console.log('or', this.orientation)
  // },
  methods: {},
  computed: {
    ...mapState(["global"]),
  },
};
</script>

<style lang="scss" scoped>
.player-spotlight {
  padding-bottom: 100px;
  @media (max-width: $md) {
    padding-bottom: 50px;
  }
  .player-spotlight-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    @media (max-width: $md) {
      padding-left: 10px;
      padding-right: 10px;
    }
  }

  h3 {
    font-family: "Poppins-Bold";
    font-size: 26px;
    color: #1a1a1a;
    letter-spacing: 0;
    line-height: 28px;
    text-transform: uppercase;
    margin-bottom: 20px;
    @media (max-width: $md) {
      margin-left: 10px;
    }
  }
  p {
    font-family: "AvenirNext-Regular";
    font-size: 14px;
    color: #3e3e3e;
    line-height: 23px;
    margin-bottom: 40px;
    &:last-child {
      margin-bottom: 0;
    }
    &:only-child {
      margin-top: 33px;
    }
    @media (max-width: $md) {
      &:first-child {
        margin-top: 20px;
      }
    }
  }
  .secondary-paragraph {
    margin-top: 48px;
    @media (max-width: $md) {
      margin-top: 60px;
    }
  }

  .dual-col {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    &.vertical {
      flex-direction: column;
    }
    @media (max-width: $md) {
      flex-direction: column;
      align-items: center;
    }
  }
  .reverseCol {
    flex-direction: row-reverse;
    @media (max-width: $md) {
      flex-direction: column;
    }
  }
  .content-column {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    min-width: 300px;
    width: 480px;
    max-width: 100%;
    &.vertical {
      width: 100%;
      align-items: center;
      h3 {
        margin-top: 38px;
      }
      p {
        padding: 0 74px;
        text-align: center;
         @media (max-width: $lg) {
          padding: 0;
        }
      }
    }
    @media (max-width: $md) {
      width: 100%;
    }
  }
  .divider {
    height: 100%;
    width: 40px;
    &.vertical {
      display: none;
    }
    @media (max-width: $md) {
      display: none;
      width: 0;
    }
  }
  .player-quote {
    width: 100%;
    height: 73px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url("~@/assets/images/bg/texture_super_wide.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    span {
      font-family: "Poppins-LightItalic";
      font-size: 21px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      line-height: 26px;
    }
  }
}
</style>


<style lang="scss">
.player-spotlight {
  .content-column {
    div,
    p {
      max-width: 100%;
    }
  }
}
</style>